import styled from 'styled-components';
import { A11YLabel } from '../../A11YLabel/A11YLabel.js';
import { Button } from '../../Button/Button.js';
import { ButtonGroupButtonType } from '../types.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';

var ItemContainer = styled.div.withConfig({
  displayName: "ButtonGroupItem__ItemContainer",
  componentId: "sc-iz0t9j-0"
})(function (_ref) {
  var theme = _ref.theme,
    type = _ref.type;
  switch (type) {
    case ButtonGroupButtonType.SEPARATE:
      return {
        position: "relative",
        display: "flex",
        flexDirection: "column",
        textAlign: "center",
        gap: 2,
        maxWidth: "60px"
      };
    case ButtonGroupButtonType.GROUPED:
      return {
        paddingInlineEnd: "5px",
        position: "relative",
        ":last-child": {
          paddingInlineEnd: 0
        },
        ":not(:last-child):after": {
          backgroundColor: theme.neutralColors.silver,
          content: '""',
          height: "calc(100% - 8px)",
          position: "absolute",
          insetInlineEnd: "1px",
          top: "50%",
          transform: "translateY(-50%)",
          width: "1px"
        }
      };
  }
});
var ItemButton = styled(Button).withConfig({
  displayName: "ButtonGroupItem__ItemButton",
  componentId: "sc-iz0t9j-1"
})(["&&{min-height:28px;padding:0 6px;", ";}&&._mntl-active{background-color:", ";cursor:default;}&&:hover,&&:focus{background-color:", ";}"], function (props) {
  switch (props.buttonType) {
    case ButtonGroupButtonType.GROUPED:
      return {
        border: "none"
      };
    case ButtonGroupButtonType.SEPARATE:
      return {
        alignSelf: "center",
        height: "36px",
        width: "60px"
      };
  }
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.neutralColors.silver;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.neutralColors.pearl;
});
var SeparatedLabel = styled(A11YLabel).withConfig({
  displayName: "ButtonGroupItem__SeparatedLabel",
  componentId: "sc-iz0t9j-2"
})(["&&{font-size:12px;align-self:center;align-items:flex-start;color:", ";line-height:14px;overflow:visible;", ";}&& span{white-space:normal;overflow:visible;}"], function (_ref4) {
  var theme = _ref4.theme;
  return theme.neutralColors.smoke;
}, function (props) {
  if (props.active) {
    return "font-weight: 600;";
  }
  if (props.disabled) {
    return "color: ".concat(props.theme.neutralColors.silver, ";");
  }
});
var ButtonGroupItem = function ButtonGroupItem(_ref5) {
  var active = _ref5.active,
    ariaLabel = _ref5["aria-label"],
    _ref5$disabled = _ref5.disabled,
    disabled = _ref5$disabled === void 0 ? false : _ref5$disabled,
    _ref5$hideLabel = _ref5.hideLabel,
    hideLabel = _ref5$hideLabel === void 0 ? false : _ref5$hideLabel,
    id = _ref5.id,
    label = _ref5.label,
    name = _ref5.name,
    onClick = _ref5.onClick,
    startAdornment = _ref5.startAdornment,
    _ref5$type = _ref5.type,
    type = _ref5$type === void 0 ? ButtonGroupButtonType.GROUPED : _ref5$type,
    value = _ref5.value;
  return /*#__PURE__*/jsx(ItemContainer, {
    type: type,
    children: type === ButtonGroupButtonType.GROUPED ? /*#__PURE__*/jsx(ItemButton, {
      variant: "tertiary",
      startAdornment: startAdornment,
      label: label,
      active: active,
      hideLabel: hideLabel || false,
      disabled: disabled,
      id: id,
      value: value,
      name: name,
      role: "radio",
      "aria-checked": active,
      onClick: onClick,
      buttonType: type,
      "aria-label": ariaLabel
    }) : /*#__PURE__*/jsxs(Fragment, {
      children: [/*#__PURE__*/jsx(ItemButton, {
        variant: "tertiary",
        startAdornment: startAdornment,
        label: label,
        active: active,
        hideLabel: true,
        disabled: disabled,
        id: id,
        value: value,
        name: name,
        role: "radio",
        "aria-checked": active,
        onClick: onClick,
        buttonType: type,
        "aria-label": ariaLabel,
        iconSize: 20
      }), /*#__PURE__*/jsx(SeparatedLabel, {
        disabled: disabled,
        active: !disabled && active,
        label: label,
        hideLabel: false
      })]
    })
  });
};
ButtonGroupItem.displayName = "ButtonGroupItem";

export { ButtonGroupItem };
